// @flow
import classnames from 'classnames';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles, useTheme } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Typography from '@material-ui/core/Typography';

import AvaMagnifyingLogoIcon from '../Icons/AvaMagnifying';

import RoundedButton from '../Buttons/RoundedButton';
import JoinConversationInput from '../JoinConversation/Input';
import JoinConversationMenu from '../JoinConversation/Menu';
import JoinConversationOption from '../JoinConversation/Option';
import JoinConversationSingleValue from '../JoinConversation/SingleValue';
import RoomAutoComplete from '../JoinConversation/RoomAutoComplete';
import PhraseMarkdownText from '../PhraseMarkdownText';

import { authInstance } from '../../firebase';

const useStyles = makeStyles(theme => ({
  button: {
    position: 'relative',
    width: 256,
    height: 40,
    paddingTop: 0,
    paddingRight: 20,
    paddingBottom: 0,
    paddingLeft: 20,
  },
  label: {
    display: 'flex',
  },
  focused: {
    border: `1px solid ${theme.palette.ava.blue2}`,
    boxShadow: '0px 0px 0px 4px rgba(3, 132, 198, 0.12)',
  },
  icon: {
    position: 'absolute',
    top: 6,
    left: 20,
  },
  search: {
    flex: 1,
  },
  cursor: {
    marginLeft: 20,
  },
}));

const Placeholder = ({ innerProps, selectProps }) => {
  const theme = useTheme();

  return (
    <Typography
      color="textSecondary"
      style={{
        color: theme.palette.ava.blue2,
        fontSize: 18,
        left: 2,
        marginLeft: selectProps.autoFocus ? 16 : 30,
        overflow: 'hidden',
        position: 'absolute',
        width: `calc(100% - ${selectProps.autoFocus ? 16 : 30}px)`,
        textAlign: selectProps.autoFocus ? 'left' : 'center',
      }}
      {...innerProps}
      noWrap
    >
      {selectProps.autoFocus ? (
        <PhraseMarkdownText phraseKey="joinConversation.enterAvaUsername" />
      ) : (
        <PhraseMarkdownText phraseKey="sidebar.buttons.joinAConversation" />
      )}
    </Typography>
  );
};

const ValueContainer = ({ children, selectProps }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        maxWidth: 170,
        height: 50,
        marginLeft: selectProps.autoFocus ? 16 : 40,
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  );
};

const components = {
  Control: JoinConversationInput,
  Menu: JoinConversationMenu,
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
  NoOptionsMessage: () => null,
  Option: JoinConversationOption,
  Placeholder,
  ClearIndicator: () => null,
  SingleValue: JoinConversationSingleValue,
  ValueContainer,
};

interface Props {
  backendSupport: any;
  branchId: string;
  classes: Object;
  electronAppLoaded: boolean;
  enableAudioMode: Function;
  fetchAsyncBackendIfNeeded: Function;
  fetchBackendSupport: Function;
  fetchUserProfile: Function;
  firebaseLoginSuccess: Function;
  getBranchIOData: Function;
  history: Object;
  scribe: any;
  setAuthenticating: Function;
  setElectronAppLoaded: Function;
  startRecord: Function;
  token: string;
}

interface State {
  avaName: string;
  buttonClicked: boolean;
  connection: boolean;
  findByAvaName: string | typeof undefined;
  supportGuest: boolean;
  loading: boolean;
  product: 'web' | 'account';
}

const JoinConversationButton = () => {
  const classes = useStyles();

  const [buttonClicked, setButtonClicked] = useState(false);

  const onAvaName = (avaName: string) => {
    localStorage.setItem('find_by_ava_name', avaName);
    authInstance.signInAnonymously();
  };

  const onSubmit = (name: string) => {
    if (!name || name.length < 3) {
      return;
    }
    if (typeof name !== 'string') return;
    onAvaName(name.slice(1));
  };

  return (
    <ClickAwayListener onClickAway={() => setButtonClicked(false)}>
      <Box>
        <RoundedButton
          className={classnames(classes.button, {
            [classes.focused]: buttonClicked,
          })}
          buttonClasses={{ label: classes.label }}
          color="white"
          onClick={() => setButtonClicked(true)}
          disableRipple
        >
          <div className={classes.icon}>
            <AvaMagnifyingLogoIcon width={24} height={24} />
          </div>
          <div className={classnames(classes.search, { [classes.cursor]: buttonClicked })}>
            <RoomAutoComplete
              autoFocus={buttonClicked}
              components={components}
              onAvaName={v => onSubmit(v)}
              onChange={() => {}}
            />
          </div>
        </RoundedButton>
      </Box>
    </ClickAwayListener>
  );
};

export default withRouter(JoinConversationButton);
